var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMonetization28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.223 10.827a.45.45 0 0 1 .389-.677h3.338v7.066l-3.727-6.39ZM15.05 17.216V10.15h3.338a.45.45 0 0 1 .39.677l-3.728 6.39Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.012 1.24a3.102 3.102 0 0 0-4.024 0l-1.655 1.411a3.101 3.101 0 0 1-1.765.732L6.4 3.554A3.101 3.101 0 0 0 3.555 6.4l-.173 2.168a3.101 3.101 0 0 1-.73 1.765L1.24 11.988a3.102 3.102 0 0 0 0 4.024l1.41 1.655c.424.497.68 1.114.732 1.765l.172 2.168A3.101 3.101 0 0 0 6.4 24.445l2.168.172a3.1 3.1 0 0 1 1.765.732l1.655 1.41a3.101 3.101 0 0 0 4.024 0l1.655-1.41a3.1 3.1 0 0 1 1.765-.732l2.168-.172a3.101 3.101 0 0 0 2.845-2.845l.172-2.168a3.1 3.1 0 0 1 .732-1.765l1.41-1.655a3.101 3.101 0 0 0 0-4.024l-1.41-1.655a3.1 3.1 0 0 1-.732-1.765L24.445 6.4A3.101 3.101 0 0 0 21.6 3.555l-2.168-.173a3.101 3.101 0 0 1-1.765-.73L16.012 1.24Zm-6.4 6.81c-1.968 0-3.195 2.135-2.203 3.835l5.684 9.744a1.05 1.05 0 0 0 1.814 0l5.684-9.744c.992-1.7-.235-3.835-2.203-3.835H9.613Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonetization28);
export default __webpack_public_path__ + "static/media/monetization_28.ecd49792.svg";
export { ForwardRef as ReactComponent };